import { forwardRef, JSX, useEffect } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { ApprovalFormController } from '~modules/media-library/controller/ApprovalFormController';
import { AssetId } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';

type ApprovalFormModalPanelProps = {
  onClose?: () => void;
  assetId: AssetId;
};

export const ApprovalFormModalPanel = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements['div'] & ApprovalFormModalPanelProps
>(function RaiseRequestModal({ onClose, className, assetId, ...TheirProps }, ref) {
  const hasAssetId = Boolean(assetId);

  useEffect(() => {
    if (!hasAssetId) {
      onClose?.();
    }
  }, [hasAssetId, onClose]);

  if (!hasAssetId) return null;

  return (
    <div
      className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg max-h-lg min-h-0 max-h-full flex flex-col relative ${
        className ? className : ''
      }`}
      {...TheirProps}
      ref={ref}
    >
      <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
        <CloseIcon />
      </Button>
      <ApprovalFormController assetId={assetId} onClose={onClose} />
    </div>
  );
});
